import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C8EC415C-81DE-4399-AEAB-FE102959F619
 * name border-none-variant
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-none-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const BorderNoneVariantIcon = createSvgIcon(<><path d="M15,5H17V3H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M7,21H9V19H7M7,5H9V3H7V5Z" /></>, 'BorderNoneVariantIcon');
export default BorderNoneVariantIcon